/**
 * Copyright (c) 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */

import {type Vec3} from '../Types';
import {type Raycaster} from './Types';

const TYPE = 'crosshair';

export default class CrosshairRaycaster implements Raycaster {
    _enabled: boolean;
    _frame: HTMLElement;

    constructor({frame}) {
        this._enabled = true;
        this._frame = frame;
    }

    enable() {
        this._enabled = true;
    }

    disable() {
        this._enabled = false;
    }

    getType(): string {
        return TYPE;
    }

    getMaxLength(): number {
        return Infinity;
    }

    fillDirection(direction: Vec3): boolean {
        if (!this._enabled) {
            return false;
        }
        direction[0] = 0;
        direction[1] = 0;
        direction[2] = -1;
        return true;
    }

    fillOrigin(origin: Vec3): boolean {
        if (!this._enabled) {
            return false;
        }
        origin[0] = 0;
        origin[1] = 0;
        origin[2] = 0;

        return true;
    }

    drawsCursor() {
        return true;
    }

    hasAbsoluteCoordinates() {
        return false;
    }
}
